var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","color":"utama","dark":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){return _vm.Tdrawer()}}}),_c('v-toolbar-title',[_vm._v("DESK PILKADA NU")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }